<template>
  <div class="moblie_box">
    <div
      :class="isSelect == 1 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(1)"
    >
      <router-link class="moblie_link" to="/WriterExamine">
        <i class="iconfont icon-kaohe"></i>我的考核</router-link
      >
    </div>
    <div
      :class="isSelect == 2 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(2)"
    >
      <router-link class="moblie_link" to="/WriterData"
        ><i class="iconfont icon-data1"></i>我的数据</router-link
      >
    </div>
    <div
      :class="isSelect == 3 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(3)"
    >
      <router-link class="moblie_link" to="/WriterDayRecordMobile">
        <i class="iconfont icon-register"></i>写手日结登记</router-link
      >
    </div>
    <div
      :class="isSelect == 4 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(4)"
    >
      <router-link class="moblie_link" to="/WriterDaySheet"
        ><i class="iconfont icon-shuji"></i>写手日结表</router-link
      >
    </div>
    <div
      :class="isSelect == 5 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(5)"
    >
      <router-link class="moblie_link" to="/WriterWeekRecordMobile">
        <i class="iconfont icon-register"></i>写手周结登记</router-link
      >
    </div>
    <div
      :class="isSelect == 6 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(6)"
    >
      <router-link class="moblie_link" to="/WriterWeekSheet">
        <i class="iconfont icon-shuji"></i>写手周结表</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isSelect: 0 //是否选择菜单项 0 ：是  1： 否
    };
  },
  methods: {
    handleMenuItem(val) {
      this.isSelect = val;
    }
  }
};
</script>
<style>
.mobile_menu_item {
  color: #000;
  margin: 10px 25px;
}
.select_menu_item {
  text-align: center;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 0px;
}
.select_menu_item .moblie_link {
  color: #157df8;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileWriterData.vue